export interface SearchParams {
  [key: string]: boolean | string | string[]
}

const reduceSearchParam = (searchParams: SearchParams, kv: string): SearchParams => {
  // tslint:disable-next-line:prefer-const
  let [key, value] = kv.split('=')

  key = decodeURIComponent(key)

  if (key.startsWith('!')) {
    searchParams[key.substr(1)] = false

  } else if (key.endsWith('[]')) {
    key = key.substr(0, key.length - 2)
    searchParams[key] = [
      ...(searchParams[key] || []) as string[],
      ...(value || '').split(',').map(decodeURIComponent)
    ]

  } else {
    searchParams[key] = value ? decodeURIComponent(value) : true
  }

  return searchParams
}

export const parseSearchParams = (searchString: string): SearchParams =>
  searchString.split('&').reduce(reduceSearchParam, {})

export const searchParams: SearchParams =
  typeof window === 'undefined' ? {} : parseSearchParams(location.search.substr(1))
